import { render, staticRenderFns } from "./EventosActuales.vue?vue&type=template&id=8465b2e6&scoped=true"
import script from "./EventosActuales.vue?vue&type=script&setup=true&lang=js"
export * from "./EventosActuales.vue?vue&type=script&setup=true&lang=js"
import style0 from "./EventosActuales.vue?vue&type=style&index=0&id=8465b2e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8465b2e6",
  null
  
)

export default component.exports